import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import BackButton from '../mobile-menu-item/BackButton';
import MobileMenuItem from '../mobile-menu-item/MobileMenuItem';
import styles from './MobileMenu.scss';

const NestedMenu = ({
  data,
  open,
  hierarchy,
  onNavigateBack,
  offScreenLeft,
}) => {
  const cn = classNames(styles.subMenu, {
    [styles.opened]: open,
    [styles.offScreenLeft]: offScreenLeft,
  });

  return (
    <div className={cn} role="menu">
      <BackButton label={data.backLabel} onClick={onNavigateBack} />
      <h3 className={styles.mobileMenu__name}>{data.name}</h3>
      {data.child.map(item => (
        <React.Fragment key={item.id}>
          {item?.child?.length > 0 ? (
            <>
              <h4 className={styles.mobileMenu__nestedHeading}>{item.name}</h4>
              <ul
                className={classNames(
                  styles.mobileMenuList__nested,
                  styles.mobileMenuList
                )}
              >
                {item?.child?.map(nestedItem => {
                  const { id, name, url } = nestedItem;
                  return (
                    <MobileMenuItem
                      key={id}
                      label={name}
                      url={url}
                      hierarchy={[...hierarchy, data.name, item.name]}
                    />
                  );
                })}
              </ul>
            </>
          ) : (
            <MobileMenuItem
              label={item.name}
              url={item.url}
              hierarchy={[...hierarchy, data.name]}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

NestedMenu.defaultProps = {
  open: false,
  offScreenLeft: false,
  onNavigateBack: undefined,
  hierarchy: [],
};

NestedMenu.propTypes = {
  open: PropTypes.bool,
  offScreenLeft: PropTypes.bool,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    child: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        url: PropTypes.string,
      })
    ),
  }).isRequired,
  onNavigateBack: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
};

export default NestedMenu;
